import { useStrategyStore } from '../../../store/strategy-store/strategy-store';
import { SideSectionSelectedEntity } from '../initiative-list/side-section/side-section-selected-entity';

export function GoalsSideSection() {
  const selectedGoal = useStrategyStore((state) => state.selectedGoal);

  if (!selectedGoal) {
    return null;
  }

  return <SideSectionSelectedEntity entity={selectedGoal} entityType="goal" />;
}
